const url = '/passenger-attributes';
const Provider = 'PassengerAttributes';
const dbModel = 'PassengerAttributes';

export { url, Provider, dbModel };
